import type { ReportSelectionSection } from '../ReportSelectionDialog';

/** Sections narrowed to the options whose label contains the search text. */
export function matchingFieldSections<TId extends string>(
  sections: readonly ReportSelectionSection<TId>[],
  search: string,
) {
  const query = search.trim().toLocaleLowerCase();
  return sections.flatMap((section) => {
    const options = section.options.filter((option) =>
      option.label.toLocaleLowerCase().includes(query),
    );
    return options.length ? [{ ...section, options }] : [];
  });
}
